import { CHAR_SYMBOL } from 'const/string/CHAR_SYMBOL';
import { IGNORED_NUMBER_SYMBOLS } from 'const/string/IGNORED_NUMBER_SYMBOLS';

export const handleKeyDownOnNumberInput = (evt) => IGNORED_NUMBER_SYMBOLS.includes(evt.key)
    && evt.preventDefault();

export const handleKeyDownOnPriceInput = (evt) => (IGNORED_NUMBER_SYMBOLS.includes(evt.key) && evt.key !== CHAR_SYMBOL.MINUS)
    && evt.preventDefault();
